// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyCCjTOQpiCvWrpKMXL3t08zlDsPgqZ4kVU",
        authDomain: "wide-game.firebaseapp.com",
        databaseURL: "https://wide-game.firebaseio.com",
        projectId: "wide-game",
        storageBucket: "wide-game.appspot.com",
        messagingSenderId: "459505349782",
        appId: "1:459505349782:web:23f2be0481177222fbbeb7",
        measurementId: "G-FL3V7CT7NK"
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
